import { render, staticRenderFns } from "./ArticleClassEdit.vue?vue&type=template&id=cbe8e5b8&"
import script from "./ArticleClassEdit.vue?vue&type=script&lang=js&"
export * from "./ArticleClassEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports